<template>
  <div class="comments">
    <template v-if="comments && comments.length">
      <image-items :items="comments" />
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ImageItems from '@components/image-items'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Comments',

  components: {
    ImageItems,
  },

  data () {
    return {}
  },

  computed: {
    ...mapGetters('Car', [
      'commentsByCarId',
    ]),

    comments () {
      return this.commentsByCarId(this.$route.params.id)
    },
  },
}
</script>

<style lang="scss" scoped></style>
